import React from "react";
//@ts-ignore
import { Icon, SelectInput } from "@viuti/recursos";
import { CoinsIcon, ClockIcon } from "@Models/icons";
import { formatToSoles } from "@Utilities/FormatsHandler";
import style from "./ServicePriceDuration.module.css";

const DURATION_OPTIONS = [15, 30, 45, 60, 90, 120, 150, 180, 240];

export const ServicePriceDuration = ({ servicePrice, serviceDuration, onDurationChange, disabled }: {
  servicePrice: number;
  serviceDuration: number;
  onDurationChange?: (val: number) => void;
  disabled?: boolean;
}) => {
  // Incluir duración actual si no está en las opciones estándar
  const options = DURATION_OPTIONS.includes(serviceDuration)
    ? DURATION_OPTIONS
    : [...DURATION_OPTIONS, serviceDuration].sort((a, b) => a - b);

  return (
    <div className={style.servicePriceDuration}>
      <div>
        <span>
          <Icon path={CoinsIcon} alt="" color={"#45348e"} size={18} />
        </span>
        <p>{formatToSoles(servicePrice)}</p>
      </div>
      <div>
        <span>
          <Icon path={ClockIcon} alt="" color={"#45348e"} size={18} />
        </span>
        {onDurationChange && !disabled ? (
          <span className={style.durationSelectWrapper}>
            <SelectInput
              label=""
              value={String(serviceDuration)}
              handleChange={(e: any) => onDurationChange(Number(e.target.value))}
              items={options.map((min) => ({ name: `${min} min`, value: String(min) }))}
            />
          </span>
        ) : (
          <p>{serviceDuration} min</p>
        )}
      </div>
    </div>
  );
};
